/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import Canvas from "./Canvas";
import Button from "./GlobalComponents/Button";
import { useContext } from "react";
import { PanelsContext } from "../Context/PanelsContext";
import MixerIcon from "../img/mixerIcon.png";

const Output = ({ isActive }) => {
  const {
    activeBg,
    setActiveBg,
    setCanvasBg,
    downloadedImg,
    downloadRef,
  } = useContext(PanelsContext);

  return (
    <div css={styles} className="output">
      <div className="heading">
        <Button
          isActive={activeBg === "bgOne"}
          onClick={() => {
            setActiveBg("bgOne");
            setCanvasBg("#111");
          }}
          btnIcon="fab fa-twitch fa-sm"
          btnText="Twitch Dark"
        />
        <Button
          isActive={activeBg === "bgTwo"}
          onClick={() => {
            setActiveBg("bgTwo");
            setCanvasBg("#fff");
          }}
          btnIcon="fab fa-twitch fa-sm"
          btnText="Twitch Light"
        />
        <Button
          isActive={activeBg === "bgThree"}
          onClick={() => {
            setActiveBg("bgThree");
            setCanvasBg("#1e2837");
          }}
          btnImg={MixerIcon}
          btnText="Mixer"
        />
      </div>
      <Canvas />
      <a ref={downloadRef} href={downloadedImg} download="twitchPanel.png">
        Download Panel
      </a>
    </div>
  );
};

const styles = css`
  width: 100%;
  max-width: 500px;
  .heading {
    width: 100%;
    display: flex;
    justify-content: space-between;
    button {
      margin: 0;
      width: 150px;
    }
  }
  a {
    text-decoration: none;
    color: #fff;
    background: #e6004e;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 16px;
    font-weight: 600;
  }
  @media (max-width: 450px) {
    .heading {
      button {
        width: 32%;
        font-size: 9px;
      }
    }
  }
  @media (min-width: 451px) and (max-width: 980px) {
    max-width: 100%;
    padding: 20px 0 0 0;
    .heading {
      justify-content: flex-start;
      button {
        margin-right: 5px;
        font-size: 11px;
      }
    }
  }
  @media (min-width: 981px) and (max-width: 1350px) {
    max-width: 48%;
    .heading {
      button {
        margin-right: 0;
        width: 32%;
      }
    }
  }
  @media (max-width: 1350px) {
    .heading {
      button {
        display: flex;
        justify-content: center;
      }
    }
  }
`;

export default Output;
